










































































































































import Vue, { PropOptions } from "vue";

import TableCampaignMessage from "@/components/campaign/TableCampaignMessage.vue";
import PageViewTabMessage from "@/components/campaign/PageViewTabMessage.vue";
import { CampaignStatus, Campaign } from "@/models";

export default Vue.extend({
  props: {
    campaign: Object as PropOptions<Campaign>,
  },
  components: { PageViewTabMessage, TableCampaignMessage },
  data() {
    return {
      tab: null,
      items: [
        {
          label: "Mensagem",
        },
        {
          label: "Enviadas",
          count: this.campaign.sentProgress,
        },
        {
          label: "Clicadas",
          count: this.campaign.clickedProgress,
        },
        {
          label: "Respondidas",
          count: this.campaign.repliedProgress,
        },
        {
          label: "Falhas",
          count: this.campaign.failedProgress,
        },
        {
          label: "Opt-Out",
          count: this.campaign.optOutProgress,
        },
      ],
    };
  },
});
